import script from "./AppStart_MS.vue?vue&type=script&setup=true&lang=js"
export * from "./AppStart_MS.vue?vue&type=script&setup=true&lang=js"

import "./AppStart_MS.vue?vue&type=style&index=0&id=662cd04c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-662cd04c"]])

export default __exports__